<!-- eslint-disable -->
<template lang="pug">
    .battle-create__block
        .battle-create-form
            .battle-create-form__header
                div(slot="title") {{ $i18n.t('battle.battle_form_createTraining') }}
            training-form
</template>

<script>
    /*eslint-disable*/
    import BoxHeader from '../../../elements/BoxHeader.vue';
    import TrainingForm from './Form.vue';
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState({
                user: state => state.auth.user,
            })
        },
        components: {
            BoxHeader,
            TrainingForm,
        }
    }
</script>

<style lang="scss" scoped>
    .battle-create__block {
        padding: 28px 30px;
        background-color: $x-color-white;
        @include media($sm) {
            border-radius: 40px;
        }
    }
    .battle-create-form {
        margin: 0;
        padding: 30px 15% 30px 15%;
        height: 100%;
        background-color: $hsl-color-gray-98;
        box-sizing: border-box;
        @include media($sm) {
            border-radius: 20px;
        }
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .battle-create-form__header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 25px;
    }
</style>
